import {
  SIGN_IN,
  SIGN_OUT,
  UPDATE_OFFSET,
  SET_CURRENT_PAGINATION_CONFIG,
  SET_SCREEN_SCROLL_OFFSET,
  SET_BANNER_IS_OPEN,
  SET_QUERY_STRING_PARAMETERS,
  SET_QUERY_STRING_PARAMETERS_TO_DEFAULT,
} from './constants'
import { DEFAULT_SETTINGS } from '../../utils/paginationCoordinator'
import { SEARCH_BAR_ITEMS_OPTIONS } from 'resources'

const initialState = {
  offset: DEFAULT_SETTINGS.offset,
  queryStringParameters: {
    '/revenue-centers': {
      per: 25,
      page: 1,
      searchBy: 'name',
      searchFor: '',
      serviceType: '',
      sortBy: 'name',
    },
    '/items': {
      per: 25,
      page: 1,
      searchBy: SEARCH_BAR_ITEMS_OPTIONS[0].uuid,
      searchFor: '',
    },
    '/sales-events': {
      per: 25,
      page: 1,
      searchBy: 'name',
      searchFor: '',
    },
    '/merchants': {
      per: 25,
      page: 1,
      searchBy: 'name',
      searchFor: '',
    },
    '/custom-tenders': {
      per: 25,
      page: 1,
      searchBy: 'name',
      searchFor: '',
    },
  },
}

const state = (state = initialState, { type, payload }) => {
  switch (type) {
    case SIGN_IN: {
      return {
        ...state,
        user: {
          ...payload,
        },
      }
    }

    case SIGN_OUT: {
      return {
        ...state,
        user: initialState.user,
      }
    }

    case UPDATE_OFFSET: {
      return {
        ...state,
        offset: payload,
      }
    }

    case SET_CURRENT_PAGINATION_CONFIG: {
      const { screen, page, per } = payload

      return {
        ...state,
        screenPaginationPage: {
          [screen]: { page, per },
        },
      }
    }

    case SET_SCREEN_SCROLL_OFFSET: {
      const { screen, offset } = payload

      return {
        ...state,
        screenScrollOffset: {
          ...state.screenScrollOffset,
          [screen]: offset,
        },
      }
    }

    case SET_BANNER_IS_OPEN: {
      return {
        ...state,
        banner: {
          ...state.banner,
          ...payload,
        },
      }
    }

    case SET_QUERY_STRING_PARAMETERS: {
      const { screen, params } = payload
      return {
        ...state,
        queryStringParameters: {
          ...state.queryStringParameters,
          [screen]: {
            ...state.queryStringParameters[screen],
            ...params,
          },
        },
      }
    }

    case SET_QUERY_STRING_PARAMETERS_TO_DEFAULT: {
      return {
        ...state,
        queryStringParameters: initialState.queryStringParameters,
      }
    }

    default:
      return state
  }
}

export default state
